export default __webpack_public_path__ + "static/media/monkey22.61a2a9fb.png";